require('./axios');
require('./vue/lang');
require('./vue/components');

import Vue from 'vue';
import router from './vue/router';
import store from './vue/store';

document.querySelectorAll('#vue-app').forEach((elem) => {
  new Vue({ router, store }).$mount(elem);
});
